// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__1zGb_","marketplaceStroke":"IconEmailAttention_marketplaceStroke__NkqYu","attentionStroke":"IconEmailAttention_attentionStroke__38Efl"};